import React from "react"
import get from "lodash/get"
import { Link } from "gatsby"

const Steps = ({ data = {} }) => {
  const { sectionTitle, body, image, buttonLabel, buttonLink } = data
  return (
    <section className="solution-steps">
      <div className="container">
        <div className="row no-padding">
          <div className="col-xl-6 text-center d-flex align-items-center justify-content-center">
            <img src={get(image, "[0].url")} alt={sectionTitle} />
          </div>
          <div className="col-xl-6 d-flex align-items-center">
            <div className="step-text">
              <div>
                <h2>{sectionTitle}</h2>
                <div dangerouslySetInnerHTML={{ __html: body }} />

                {buttonLabel && buttonLink && (
                  <Link to={buttonLink} className={"btn btn-primary mt-4"}>
                    {buttonLabel}
                  </Link>
                )}

                {/*{pageData.steps.map((step, idx) => (*/}
                {/*  <React.Fragment key={idx}>*/}
                {/*    <span>0{idx + 1}</span>*/}
                {/*    <h4>{step.stepTitle}</h4>*/}
                {/*    <p>{step.stepText}</p>*/}
                {/*  </React.Fragment>*/}
                {/*))}*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Steps
